import angular from 'angular';
import uiRouter from 'angular-ui-router';
import collectionsComponent from './collections.component';
import dataTable from 'angular-material-data-table';

let collectionsModule = angular.module('collections', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('collections', {
        url: '/collections',
        component: 'collections',
        parent: 'main',
        data: {
            permissions: {
                only: ['OPERATOR'],
                redirectTo: 'home'
            }
        },
        resolve: {
            user: (LoginService) => {
                return LoginService.getCurrent();
            }
        }
    });
})
.component('collections', collectionsComponent)
.name;

export default collectionsModule;
